import type { CityConfig } from "../city-template/types";

export const oakParkConfig: CityConfig = {
  city: "Oak Park",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "oak-park",
  route: "/cities/oak-park",
  title: "Emergency Passport Oak Park, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Oak Park, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Oak Park, River Forest, Forest Park, and all near west suburban Cook County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Oak Park, IL",
  heroSubtitle: "Oak Park architect heading to a Frank Lloyd Wright conference in Japan next week? River Forest family vacation to Europe and your passport's expired? Forest Park business trip to London with 5 days notice? We help Oak Park and near west suburban residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Oak%20Park%20Illinois%20historic%20Frank%20Lloyd%20Wright%20Home%20and%20Studio%20architecture%2C%20tree-lined%20streets%20with%20Victorian%20and%20Prairie-style%20homes%2C%20downtown%20Oak%20Park%20Lake%20Street%20commercial%20district%20with%20boutique%20shops%20and%20cafes%2C%20Unity%20Temple%20exterior%20with%20modern%20visitors%2C%20warm%20autumn%20afternoon%20with%20golden%20leaves%2C%20charming%20near-west%20Chicago%20suburb%20professional%20photography&width=1800&height=700&seq=oakpark-hero-001&orientation=landscape",
  heroImageAlt: "Oak Park Illinois historic Frank Lloyd Wright architecture and tree-lined neighborhoods",
  geoPosition: "41.8850;-87.7845",
  geoPlacename: "Oak Park, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 25 minutes east of Oak Park via I-290 or CTA Green Line",
  },
  nearbyCitiesZips: [
    { name: "Oak Park", zips: "60301, 60302, 60304" },
    { name: "River Forest", zips: "60305" },
    { name: "Forest Park", zips: "60130" },
    { name: "Elmwood Park", zips: "60707" },
    { name: "Cicero", zips: "60804" },
    { name: "Berwyn", zips: "60402" },
    { name: "Riverside", zips: "60546" },
    { name: "North Riverside", zips: "60546" },
    { name: "Broadview", zips: "60155" },
    { name: "Maywood", zips: "60153" },
    { name: "Melrose Park", zips: "60160" },
    { name: "Westchester", zips: "60154" },
    { name: "La Grange", zips: "60525" },
    { name: "Brookfield", zips: "60513" },
    { name: "Hillside", zips: "60162" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 25 minutes east via I-290" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-4-line", title: "Near West Suburban Hub", desc: "Serving Oak Park, River Forest, and Forest Park professionals and families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no downtown Chicago trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Cicero, IL", route: "/cities/cicero" },
    { name: "Emergency passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Urgent passport services in Forest Park, IL", route: "/states/illinois" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Oak Park, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes east via I-290 or the CTA Green Line) — without you making the trip. Oak Park residents can ship from any UPS or FedEx along Lake Street or Harlem Avenue.",
  fpcOfficeDistance: "Serving Oak Park, River Forest, Forest Park, Elmwood Park, Cicero, Berwyn, Riverside, North Riverside, Broadview, Maywood, Melrose Park, Westchester, La Grange, Brookfield, Hillside, and all near west suburbs",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Oak Park and Chicago's near west suburbs. From the Frank Lloyd Wright Historic District and the Unity Temple campus to the Pleasant District and downtown Lake Street, from the mansions of River Forest to the Madison Street corridor of Forest Park — we serve all of the near western suburbs and beyond.",
  nearbyCitiesIntro: "We serve Oak Park and all nearby communities including River Forest, Forest Park, Elmwood Park, Cicero, Berwyn, Riverside, North Riverside, Broadview, Maywood, Melrose Park, Westchester, La Grange, Brookfield, and Hillside. We also serve all near west suburban Cook County.",
  howItWorksIntro: "Most Oak Park travelers complete everything online and ship documents overnight. No need to drive 25 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Oak Park is one of Chicago's most architecturally significant suburbs with a highly educated professional community that travels internationally year-round. Here are the most common passport mistakes we see from Oak Park and near west suburban travelers.",
  testimonialsIntro: "Oak Park and near west suburban travelers — from Frank Lloyd Wright enthusiasts to academic professionals to globally-minded families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Oak Park, IL? Here are the most common ones we hear from near west suburban Cook County travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for near west suburban professionals and families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25 minutes to downtown Chicago", "CTA Green Line or I-290 to the Loop"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Oak Park travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 25 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Near west suburban professional and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Oak Park adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Oak Park address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Oak Park residents — including families, young professionals, and new citizens.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Oak Park residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Oak Park and River Forest families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Oak Park and Cook County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Oak Park IL", description: "Urgent passport processing for Oak Park Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Oak Park IL", description: "Fast passport renewal for Oak Park Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Oak Park IL", description: "New passport application services for Oak Park Illinois residents applying for their first passport." },
    { name: "Child Passport Oak Park IL", description: "Minor passport services for Oak Park Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jonathan W.",
      location: "Oak Park, IL",
      rating: 5,
      text: "Architecture conference in Barcelona with 5 days notice and my passport had expired. Fast Passport Center had my renewal in 36 hours. I shipped from the Lake Street UPS between client meetings. The dedicated agent was incredible.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Eleanor B.",
      location: "River Forest, IL",
      rating: 5,
      text: "Family trip to Italy — two adult renewals and a child passport for our daughter. Fast Passport Center got all three done in 4 days. We shipped from the Harlem Avenue FedEx. Absolutely seamless service for near west suburban families!",
      service: "Family Passport Bundle",
    },
    {
      name: "Michael T.",
      location: "Oak Park, IL",
      rating: 5,
      text: "International consulting engagement in Tokyo with 8 days notice. Fast Passport Center processed my new passport in 3 days. I'm a downtown Chicago commuter and avoiding the agency trip saved me a full day of work.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "opk-1",
      name: "Oak Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "901 Lake St",
      city: "Oak Park",
      state: "IL",
      zip: "60301",
      phone: "(708) 848-5192",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Oak Park, Lake Street corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Oak Park acceptance facility. Appointments required — book 1–2 weeks in advance. Near CTA Green Line and Metra.",
      icon: "ri-mail-line",
    },
    {
      id: "opk-2",
      name: "Forest Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "417 Des Plaines Ave",
      city: "Forest Park",
      state: "IL",
      zip: "60130",
      phone: "(708) 366-2049",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Forest Park, approximately 2 miles east of Oak Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Forest Park and eastern Oak Park residents. Near CTA Blue Line terminal.",
      icon: "ri-mail-line",
    },
    {
      id: "opk-3",
      name: "Cook County Clerk — Maywood",
      type: "County Clerk Passport Acceptance",
      address: "1311 Maybrook Square, Room 105",
      city: "Maywood",
      state: "IL",
      zip: "60153",
      phone: "(312) 603-5656",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Maywood, approximately 3 miles south of Oak Park",
      website: "https://www.cookcountyclerk.com/",
      websiteLabel: "Cook County Clerk",
      notes: "Cook County Clerk satellite passport acceptance. Serves near west suburbs. Call ahead to confirm hours.",
      icon: "ri-government-line",
    },
    {
      id: "opk-4",
      name: "Berwyn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6625 Cermak Rd",
      city: "Berwyn",
      state: "IL",
      zip: "60402",
      phone: "(708) 788-0041",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Berwyn, approximately 3 miles south of Oak Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Berwyn, Riverside, and southern Oak Park residents. Near Berwyn Depot District.",
      icon: "ri-mail-line",
    },
    {
      id: "opk-5",
      name: "Elmwood Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7300 W Fullerton Ave",
      city: "Elmwood Park",
      state: "IL",
      zip: "60707",
      phone: "(708) 453-9100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Elmwood Park, approximately 3 miles northwest of Oak Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Elmwood Park and northern Oak Park residents. Good alternative facility.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25 min drive to downtown Chicago", fpc: "No — ship from Oak Park" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Professional Conference Deadlines",
      description: "Oak Park professionals attending international conferences often discover passport issues days before departure. Academic and architectural conference seasons create peak demand — start your application at least 6 weeks out.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Lake Street and Harlem Avenue sometimes produce photos that don't meet strict State Department standards. Photos must be exactly 2x2 inches on a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type cause rejections at the Oak Park Post Office and Forest Park acceptance facilities. Verify which form you need before your appointment.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Trip to Chicago Agency",
      description: "Many Oak Park residents attempt to drive or take the CTA to the Chicago Passport Agency. While it's only 25 minutes away, appointments fill 2–3 weeks out and downtown parking is expensive. Our courier is faster and more reliable.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "Both parents must appear or submit notarized consent for child passports. Oak Park professional couples sometimes arrive with only one parent present at acceptance facilities.",
    },
    {
      icon: "ri-global-line",
      title: "International Student Travel",
      description: "Oak Park high school and college students traveling for study abroad programs need 6-month passport validity beyond their return date. Check your expiry well before the semester starts.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Oak Park or River Forest area." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Lake Street or Harlem Avenue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — professional, fast, zero errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 25 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Oak Park address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Oak Park, IL?", a: "Fast Passport Center offers emergency passport processing in Oak Park, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes east via I-290) — without you making the trip." },
    { q: "Does Oak Park have its own passport agency?", a: "No — Oak Park does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 25 minutes east via I-290 or the CTA Green Line). Fast Passport Center's courier service means Oak Park residents never need to make the trip." },
    { q: "Can I get an expedited passport in River Forest or Forest Park?", a: "Absolutely. Fast Passport Center serves all near west suburbs including River Forest, Forest Park, Elmwood Park, Cicero, Berwyn, Riverside, North Riverside, and all western Cook County communities. Our service works the same way everywhere." },
    { q: "What airport do Oak Park travelers use for international flights?", a: "Both Chicago O'Hare (ORD — 20 minutes west) and Chicago Midway (MDW — 15 minutes south) serve Oak Park. O'Hare offers more extensive international routes. Proximity to both airports makes Oak Park one of the best-positioned suburbs for international travel." },
    { q: "Where can I get passport photos in Oak Park?", a: "Walgreens and CVS locations on Lake Street and Harlem Avenue offer passport photos. UPS Store on Lake Street also provides them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get a child's passport expedited in Oak Park?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Oak Park and the near west suburbs. Both parents or legal guardians must typically be present at the acceptance facility." },
    { q: "How far is the Chicago Passport Agency from Oak Park?", a: "The Chicago Passport Agency is approximately 25 minutes east via I-290 or the CTA Green Line. Oak Park is one of the closest suburbs to the agency, but you still need an appointment (2–3 week wait) and downtown parking. Our courier is simpler and faster." },
    { q: "Do you serve Oak Park's architectural tour and study groups?", a: "Yes. Fast Passport Center is experienced with the unique travel needs of Oak Park's architecture and design community — from international conferences to Frank Lloyd Wright study tours abroad. Fast, reliable service for professionals and enthusiasts alike." },
  ],
  photoLocations: [
    { name: "Walgreens — Oak Park", address: "6410 Roosevelt Rd, Oak Park, IL 60304", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Oak Park", address: "1100 Lake St, Oak Park, IL 60301", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Oak Park", address: "711 N Harlem Ave, Oak Park, IL 60302", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Forest Park", address: "7203 Roosevelt Rd, Forest Park, IL 60130", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Chicago West", address: "5301 W Lexington St, Chicago, IL 60644", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Nearest to Oak Park — approximately 4 miles east. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Melrose Park", address: "1903 N Mannheim Rd, Melrose Park, IL 60160", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves near west suburbs. Full REAL ID processing available. Approximately 5 miles west of Oak Park.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Oak Park and near west suburbs" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Oak Park and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 20 minutes west via I-290 and I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub — United and American Airlines hub. Extensive direct flights to Europe, Asia, and the Americas.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 15 minutes south via Harlem Avenue and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub. Convenient for domestic flights and Southwest international routes to Mexico and the Caribbean.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};